import React, {useEffect,useState} from 'react';
import makeStyles from '@material-ui/styles/makeStyles';
import Dialog from "@material-ui/core/Dialog";
import {DialogTitle} from "../../../components";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button"; 
import PurchasePayment from "./purchasePayment";
import {MaterialTable} from '../../../components';
import Icon from '@material-ui/core/Icon';
import moment from 'moment';
import useTheme from '@material-ui/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import PPMobileCardView from '../../../components/PPMobileCardView';

const useStyles = makeStyles(theme => ({
    button: {
        margin: theme.spacing(2, 0)
    }
}));

let currentPayment = undefined
let editPaymentMode = false
const PurchasePayementDetails = ({onPaymentEdit, data , banks,   handlePaymentDetailsClose, showPaymentDetailsDialog, 
    onPurchasePaymentSave, onPurchasePaymentDelete, loading}) => {
    const classes = useStyles();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true
    });
    const [showPaymentDialog, setShowPaymentDialog] = useState(false)
    const [linePurchasePayments, setLinePurchasePayments] = useState([])

    const reset = () => {
        console.debug(data)
        if(showPaymentDetailsDialog && data !== undefined && data.linePurchasePayments !== undefined && data.linePurchasePayments !== null){
            console.debug(data)
            setLinePurchasePayments(data.linePurchasePayments);
        }else{
            setLinePurchasePayments([])
        }
    };
    useEffect(reset, [showPaymentDetailsDialog,data]);


    function onNewPayment(event) {
        editPaymentMode = false;
        event.preventDefault();
        setShowPaymentDialog(true);
    } 

    function onEdit(rowData) {
        rowData = {
            ...rowData,
            bankIndex:banks.findIndex((bank)=>{return bank.id === rowData.paymentBankId;})
        };
        currentPayment = rowData
        editPaymentMode = true
        setShowPaymentDialog(true);
    }

    function onPaymentDelete(rowData) {
        console.debug(rowData,linePurchasePayments)
        let index = linePurchasePayments.findIndex((srcPurchasePayment) => {
            return srcPurchasePayment.id === rowData.id;
        });
        let newPurchasePayments = linePurchasePayments;
        newPurchasePayments.splice(index, 1); 
        console.debug(newPurchasePayments)
        setLinePurchasePayments(newPurchasePayments)
        let tempCurrentData = {
            ...data,
            linePurchasePayments :newPurchasePayments
        }
        onPurchasePaymentDelete(rowData, tempCurrentData)
        console.debug(linePurchasePayments)
    }


    function onPaymentSave(payment) {
        console.debug(payment)
        console.debug(linePurchasePayments)
        if(editPaymentMode){
            let index = linePurchasePayments.findIndex((srcPayement) => {
                return srcPayement.id === payment.id;
            });
            setLinePurchasePayments([...linePurchasePayments.slice(0, index),
                {...payment},
                ...linePurchasePayments.slice(index + 1)])
    
            let tempCurrentData ={
                ...data,
                linePurchasePayments :[...linePurchasePayments.slice(0, index),
                    {...payment},
                    ...linePurchasePayments.slice(index + 1)]
            }
            onPaymentEdit(payment, tempCurrentData)
        }else{
            payment = {
                ...payment,
                purchaseId : data.id
            }
            onPurchasePaymentSave(payment)
        }
        setShowPaymentDialog(false);
        console.debug(linePurchasePayments)
    }


    function handlePaymentClose() {
        currentPayment = undefined;
        setShowPaymentDialog(false);
    }

    let actions = [
        rowData => ({
            icon: () => <Icon color='primary'>edit</Icon>,
            tooltip: 'Edit purchase Details',
            onClick: (event, rowData) => onEdit(rowData),
            hidden:rowData.paymentNote === "Bulk Payment" ? true : false
        }),
        rowData => ({
            icon: () => <Icon color='error'>delete</Icon>,
            tooltip: 'Delete purchase Details',
            onClick: (event, rowData) => onPaymentDelete(rowData),
            hidden:rowData.paymentNote === "Bulk Payment" ? true : false
        })
    ]
    const paymentModeText = rowData => rowData.paymentMode === 0 ? '' : (rowData.paymentMode === 1 ? 'Cash' : rowData.paymentBankName.String)
    return <Dialog maxWidth='md' open={showPaymentDetailsDialog} onClose={handlePaymentDetailsClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog- title"   >Purchase Payements</DialogTitle>
          <DialogContent  >
            <div className={classes.button} >
                <Button variant="contained" color="primary" onClick={onNewPayment}>Add Payment</Button>
            </div>

            {/* pp-dialog-card-table: mobile cards sit on the white dialog instead of the grey table background */}
            <div className="pp-dialog-card-table">
            <MaterialTable
            isLoading={loading}
            columns={[
                {title: 'id', field: 'id', hidden: true},
                {
                    hidden: isDesktop,
                    render: rowData => <PPMobileCardView
                        title={moment(rowData.paymentDate).format("DD-MM-YYYY")}
                        rows={[
                            { label: 'Payment Amount', value: rowData.paymentAmount, bold: true },
                            { label: 'Payment Mode', value: paymentModeText(rowData) },
                            { label: 'Payment Note', value: rowData.paymentNote, fullWidth: true },
                        ]}
                        // Same as desktop: no Edit/Delete for bulk payments
                        menuItems={rowData.paymentNote === "Bulk Payment" ? undefined : [
                            { label: 'Edit', onClick: () => onEdit(rowData) },
                            { label: 'Delete', onClick: () => onPaymentDelete(rowData) },
                        ]}
                    />
                },
                {title: 'Payment Date', field: 'paymentDate',  editable: 'never', hidden: !isDesktop,
                render: rowData => {
                    return <span>{moment(rowData.paymentDate).format("DD-MM-YYYY")}</span>
                }
                },
                {title: 'Payment Amount', field: 'paymentAmount',  editable: 'never', hidden: !isDesktop},
                {title: 'Payment Mode', field: 'paymentMode', editable: 'never', hidden: !isDesktop,
                render: rowData => {
                    return <span>{paymentModeText(rowData)}</span>
                }
                },
                {title: 'paymentBankId', field: 'paymentBankId', editable: 'never', hidden: true},
                {title: 'Payment Note', field: 'paymentNote', editable: 'never', hidden: !isDesktop},
            ]}
            data={linePurchasePayments}
            options={{
                actionsColumnIndex: -1,
                search: false,
                showTitle: false,
                
                toolbar: false,
                header: isDesktop,
                paging:false
            }} 
            //style={{boxShadow: 'unset'}}
            actions={isDesktop ? actions : []}
            /> 
            </div>

            {showPaymentDialog ? 

                <PurchasePayment banks={banks} data={currentPayment} onSave={onPaymentSave} handlePaymentClose={handlePaymentClose} 
                showPaymentDialog={showPaymentDialog} editMode={editPaymentMode} >
                </PurchasePayment> 

                : null
            }
            <DialogActions>
                <Button
                    className={classes.button}
                    color="primary"
                    size="large"
                    type="submit"
                    variant="contained"
                    onClick={handlePaymentDetailsClose}
                >
                    Close
                </Button>
            </DialogActions>
        </DialogContent>
    </Dialog>
};

export default PurchasePayementDetails;